export default __webpack_public_path__ + "static/media/favorites-pilates.a60c0559.png";